import { useAppStore } from "@/store/appStore";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useModelViewerStore } from "@/store/modelViewerStore";
import CloseButton from "src/components/button/close-button";
import { useNavigate } from "react-router-dom";

const AugmentedRealityViewerLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  let navigate = useNavigate();
  const closeAr = () => {
    navigate("/");
  };

  return (
    <div className="fullscreen_div">
      {children}
      <div className="flex w-full justify-end items-center px-[20px] pt-[20px]">
        <CloseButton
          goBack={false}
          onClick={() => closeAr()}
          withGlassBg={true}
        />
      </div>
    </div>
  );
};
export default AugmentedRealityViewerLayout;
